var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.071,
    height: 29.428,
    viewBox: "0 0 22.071 29.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_57385",
    "data-name": "Group 57385",
    transform: "translate(-931.5 -444.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57384",
    "data-name": "Group 57384",
    transform: "translate(861.5 308.124)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54040",
    "data-name": "Group 54040",
    transform: "translate(70 135.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54051",
    "data-name": "Group 54051",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53785",
    "data-name": "Group 53785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53784",
    "data-name": "Group 53784",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25691",
    "data-name": "Path 25691",
    d: "M62.236,9.81c0-5.417-2.473-9.81-5.518-9.81S51.2,4.392,51.2,9.81a5.5,5.5,0,0,0,3.566,5.144l-.5,12.022a2.452,2.452,0,1,0,4.9,0l-.5-12.021A5.5,5.5,0,0,0,62.236,9.81Z",
    transform: "translate(-51.2 0)",
    fill: "#ff8900"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53787",
    "data-name": "Group 53787",
    transform: "translate(12.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53786",
    "data-name": "Group 53786",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25692",
    "data-name": "Path 25692",
    d: "M239.6,8.89,239.29,0h-1.533l-.306,8.89h-1.226L235.918,0h-1.839l-.306,8.89h-1.226L232.239,0h-1.533L230.4,8.89a4.592,4.592,0,0,0,2.725,4.191l-.58,13.895a2.452,2.452,0,1,0,4.9,0l-.58-13.895A4.592,4.592,0,0,0,239.6,8.89Z",
    transform: "translate(-230.4)",
    fill: "#ff8900"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_57337",
    "data-name": "Group 57337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53785-2",
    "data-name": "Group 53785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53784-2",
    "data-name": "Group 53784",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25691-2",
    "data-name": "Path 25691",
    d: "M62.236,9.81c0-5.417-2.473-9.81-5.518-9.81S51.2,4.392,51.2,9.81a5.5,5.5,0,0,0,3.566,5.144l-.5,12.022a2.452,2.452,0,1,0,4.9,0l-.5-12.021A5.5,5.5,0,0,0,62.236,9.81Z",
    transform: "translate(-51.2 0)",
    fill: "#ff8900"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53787-2",
    "data-name": "Group 53787",
    transform: "translate(12.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53786-2",
    "data-name": "Group 53786",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25692-2",
    "data-name": "Path 25692",
    d: "M239.6,8.89,239.29,0h-1.533l-.306,8.89h-1.226L235.918,0h-1.839l-.306,8.89h-1.226L232.239,0h-1.533L230.4,8.89a4.592,4.592,0,0,0,2.725,4.191l-.58,13.895a2.452,2.452,0,1,0,4.9,0l-.58-13.895A4.592,4.592,0,0,0,239.6,8.89Z",
    transform: "translate(-230.4)",
    fill: "#ff8900"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.f63f25d325bfd0b4c5fec0e3d8670ef9.svg";
export { ForwardRef as ReactComponent };